import { teamData } from '@/models/team-member.model';
import { UsersService } from '@/services/api/users.service';
import { CommonModule, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { UserData } from 'src/app/models/user-data.model';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarGroupModule } from 'primeng/avatargroup';

@Component({
    selector: 'app-user-avatar',
    standalone: true,
    imports: [
      ChipModule, 
      CommonModule, 
      AvatarModule,
      TooltipModule,
      AvatarGroupModule 
    ],
    template: `
<p-avatar shape="circle" *ngIf="userImage && !showLabel" size="normal" [image]="userImage" [pTooltip]="user?.DisplayName || user?.displayName || ''" class="avatar-align"/>
<p-avatar shape="circle" *ngIf="!userImage && !showLabel" [label]="getInitials()" size="normal" [pTooltip]="user?.DisplayName || user?.displayName || ''" class="avatar-align text-avatar"/>
  `,
  styles: [`
    .avatar-align {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    
    .text-avatar ::ng-deep .p-avatar-text {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      line-height: 1 !important;
    }
  `]
})
export class UserAvatarComponent {
  @Input() user: UserData | Partial<UserData> | teamData | undefined;
  @Input() showLabel:boolean = true

  constructor(private usersService: UsersService) {
  }

  get userImage() {
    if (this.user && this.user.UID) {
      const userList = this.usersService.userList();
      const user = userList?.find((u: UserData) => u.UID === this.user?.UID);
      if (user && user.profilePicture) {
        return 'data:image/jpeg;base64,' + user.profilePicture;
      }
    } 
    return null;
    
  }

  getInitials() {
    if(!this.user) return 'N/A';
    const firstName = this.user?.DisplayName?.split(' ')[0] || '';
    const lastName = this.user?.DisplayName?.split(' ')[1] || '';
    return (firstName[0] || '') + (lastName[0] || '');
  }
}